import React from 'react'

class SubjectLevelResultsPartial extends React.Component {

  onClick = () => {
    this.props.onClick(this.props.result)
  }

  render() {
    return (
      <li className="-mt-px cursor-pointer border border-border bg-card px-4 py-2 text-sm first:mt-0 first:rounded-t-[10px] last:rounded-b-[10px] hover:bg-muted/50" onClick={this.onClick}>
        {this.props.result.name}
      </li>
    )
  }
}

export default SubjectLevelResultsPartial
